module.exports = __webpack_public_path__ + "66cbfc5859cab2eeb1a38b74e03b0c90.svg";